"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
const shouldOpenPreferencesModal = ({
  service,
  bookingsSettings,
  experiments,
  isDummy
}) => {
  if (!(0, _bookingsCalendarCatalogViewerMapper.isBookFlowSettingsEnabled)({
    experiments,
    bookingsSettings
  })) {
    return deprecatedOpenPreferencesModalCondition({
      service,
      bookingsSettings,
      experiments,
      isDummy
    });
  }
  if (isDummy || !(0, _bookingsCalendarCatalogViewerMapper.isAppointmentService)(service)) {
    return false;
  }
  const isStaffSelectionAllowed = (0, _bookingsCalendarCatalogViewerMapper.isCustomerMayChooseStaff)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isCustomerMustChooseStaff)(bookingsSettings);
  const mustSelectStaffBeforeSlot = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiStaff)(service) && (0, _bookingsCalendarCatalogViewerMapper.isStaffSelectionBeforeSlot)(bookingsSettings) && isStaffSelectionAllowed;
  const mustSelectLocationBeforeSlot = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiBusinessLocations)(service) && (0, _bookingsCalendarCatalogViewerMapper.isLocationSelectionBeforeSlot)(bookingsSettings);
  return (0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isServiceWithDynamicDuration)(service) || (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service, experiments) || mustSelectStaffBeforeSlot || mustSelectLocationBeforeSlot;
};
exports.shouldOpenPreferencesModal = shouldOpenPreferencesModal;
const deprecatedOpenPreferencesModalCondition = ({
  service,
  bookingsSettings,
  experiments,
  isDummy
}) => {
  const isMultiServicesAppointmentsEnable = !isDummy && (0, _bookingsCalendarCatalogViewerMapper.isAppointmentService)(service) && (0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings);
  const isServicePreferencesAppointmentsEnable = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithDynamicDuration)(service);
  const isAppointmentWithAddOns = (0, _bookingsCalendarCatalogViewerMapper.isAppointmentService)(service) && (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service, experiments);
  return isMultiServicesAppointmentsEnable || isServicePreferencesAppointmentsEnable || isAppointmentWithAddOns;
};
//# sourceMappingURL=shouldOpenPreferencesModal.js.map